'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp, _dec2, _class3, _class4, _temp2, _dec3, _class5, _class6, _temp3, _dec4, _class7, _class8, _temp4, _dec5, _class9, _class10, _temp5, _dec6, _dec7, _dec8, _class11, _class12, _temp6;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _lodash = require('lodash');

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _reactLoader = require('react-loader');

var _reactLoader2 = _interopRequireDefault(_reactLoader);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _reduxAsyncConnect = require('redux-async-connect');

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _convert = require('../../helpers/convert');

var _convert2 = _interopRequireDefault(_convert);

var _analytics = require('../../helpers/analytics');

var _analytics2 = _interopRequireDefault(_analytics);

var _reactFlexboxGrid = require('react-flexbox-grid');

var _components = require('../../components');

var _search = require('redux/modules/search');

var searchActions = _interopRequireWildcard(_search);

var _FundFossilFinanceInvestments = require('./FundFossilFinanceInvestments.css');

var _FundFossilFinanceInvestments2 = _interopRequireDefault(_FundFossilFinanceInvestments);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// we could do pagination a few at a time, but we'll do click to show all
var FirstPage = 5;
var AllPage = 1000000;

function mapFundHoldings(fHoldings) {
  var fHoldingsMap = {};
  fHoldings.forEach(function (fholding) {
    fHoldingsMap[fholding.db_holding_id] = fholding;
  });
  return fHoldingsMap;
}

function filterHoldings(fHoldingsMap, holdings, filterFn) {
  // console.log('filtering holdings!!')
  // console.log(filterFn)
  return (0, _lodash.chain)(holdings).filter(filterFn).sortBy(function (o) {
    return fHoldingsMap[o.id].market_value * -1;
  })
  // .take(10)
  .value();
}

var SectorDetailsSwitches = (_dec = (0, _reactCssModules2.default)(_FundFossilFinanceInvestments2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(SectorDetailsSwitches, _Component);

  function SectorDetailsSwitches(props) {
    (0, _classCallCheck3.default)(this, SectorDetailsSwitches);
    return (0, _possibleConstructorReturn3.default)(this, (SectorDetailsSwitches.__proto__ || (0, _getPrototypeOf2.default)(SectorDetailsSwitches)).call(this, props));
  }

  (0, _createClass3.default)(SectorDetailsSwitches, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          increment = _props.increment,
          sector = _props.sector,
          fund = _props.fund,
          shareClass = _props.shareClass,
          fHoldingsMap = _props.fHoldingsMap,
          sectorPages = _props.sectorPages;

      //

      return _react2.default.createElement(
        'div',
        { id: 'sector-id-' + sector[0] },
        _react2.default.createElement(
          SectorDetailsSwitch,
          {
            type: sector[0],
            label: sector[1],
            sublabel: sector[2],
            count: fund[sector[3]],
            weight: fund[sector[4]],
            asset: fund[sector[5]],
            currency: shareClass.currency
          },
          _react2.default.createElement(HoldingListDisplay, {
            increment: increment,
            shareClass: shareClass,
            fHoldingsMap: fHoldingsMap,
            type: sector[0],
            label: sector[1],
            count: shareClass[sector[3]],
            holdings: sector[6],
            pages: sectorPages,
            score: fund[sector[7]]
          })
        )
      );
    }
  }]);
  return SectorDetailsSwitches;
}(_react.Component), _class2.propTypes = {
  increment: _react.PropTypes.func,
  sector: _react.PropTypes.array,
  fund: _react.PropTypes.object,
  shareClass: _react.PropTypes.object,
  fHoldingsMap: _react.PropTypes.object,
  sectorPages: _react.PropTypes.object
}, _temp)) || _class);
var SectorDetailsSwitch = (_dec2 = (0, _reactCssModules2.default)(_FundFossilFinanceInvestments2.default, { allowMultiple: true }), _dec2(_class3 = (_temp2 = _class4 = function (_Component2) {
  (0, _inherits3.default)(SectorDetailsSwitch, _Component2);

  function SectorDetailsSwitch(props) {
    (0, _classCallCheck3.default)(this, SectorDetailsSwitch);
    return (0, _possibleConstructorReturn3.default)(this, (SectorDetailsSwitch.__proto__ || (0, _getPrototypeOf2.default)(SectorDetailsSwitch)).call(this, props));
  }

  (0, _createClass3.default)(SectorDetailsSwitch, [{
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          type = _props2.type,
          label = _props2.label,
          sublabel = _props2.sublabel,
          count = _props2.count,
          weight = _props2.weight,
          asset = _props2.asset,
          currency = _props2.currency;

      // filled in or greyed out?

      var currIcon = _convert2.default.int(count) ? require('../../../static/images/icn-' + type + '.svg') : require('../../../static/images/icn-' + type + '-inactive.svg');

      //
      return _react2.default.createElement(
        'div',
        { styleName: 'detail-sector-wrapper' },
        _react2.default.createElement(
          'div',
          { styleName: 'detail-sector-title-stats-flex' },
          _react2.default.createElement(
            'div',
            { styleName: 'detail-sector-title-icon-wrap' },
            _react2.default.createElement(
              'div',
              { styleName: 'detail-sector-detail-icon-wrap' },
              _react2.default.createElement('img', { styleName: 'detail-icon', src: currIcon, alt: label })
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'detail-title' },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'b',
                  null,
                  label
                )
              ),
              sublabel ? _react2.default.createElement(
                'div',
                { styleName: 'detail-sublabel' },
                sublabel
              ) : null
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'detail-stats-wrapper' },
            _react2.default.createElement(
              'div',
              { styleName: 'detail-stat' },
              _react2.default.createElement(
                'div',
                { styleName: 'detail-stat-value' },
                _format2.default.number(count)
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'detail-stat-label' },
                'holdings'
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'detail-stat' },
              _react2.default.createElement(
                'div',
                { styleName: 'detail-stat-value' },
                _format2.default.money(asset, true, currency, true)
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'detail-stat-label' },
                'invested'
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'detail-stat' },
              _react2.default.createElement(
                'div',
                { styleName: 'detail-stat-value' },
                _format2.default.perc(weight)
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'detail-stat-label' },
                'of fund'
              )
            )
          )
        ),
        this.props.children
      );
    }
  }]);
  return SectorDetailsSwitch;
}(_react.Component), _class4.propTypes = {
  type: _react.PropTypes.string,
  label: _react.PropTypes.string,
  sublabel: _react.PropTypes.string,
  count: _react.PropTypes.string,
  weight: _react.PropTypes.string,
  asset: _react.PropTypes.string,
  currency: _react.PropTypes.string
}, _temp2)) || _class3);
var HoldingListDisplay = (_dec3 = (0, _reactCssModules2.default)(_FundFossilFinanceInvestments2.default, { allowMultiple: true }), _dec3(_class5 = (_temp3 = _class6 = function (_Component3) {
  (0, _inherits3.default)(HoldingListDisplay, _Component3);

  function HoldingListDisplay(props) {
    (0, _classCallCheck3.default)(this, HoldingListDisplay);
    return (0, _possibleConstructorReturn3.default)(this, (HoldingListDisplay.__proto__ || (0, _getPrototypeOf2.default)(HoldingListDisplay)).call(this, props));
  }

  (0, _createClass3.default)(HoldingListDisplay, [{
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          increment = _props3.increment,
          shareClass = _props3.shareClass,
          fHoldingsMap = _props3.fHoldingsMap,
          type = _props3.type,
          label = _props3.label,
          count = _props3.count,
          holdings = _props3.holdings,
          pages = _props3.pages;


      var _count = _convert2.default.int(count);
      if (_count === 0) {
        return null;
      }

      var page = pages[type] || 0;
      var hasMoreButton = page === 1 && _count > FirstPage ? _react2.default.createElement(
        'div',
        { styleName: 'show-more-holdings-btn', onClick: increment(type) },
        'Show all',
        _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-angle-double-down' })
      ) : null;
      //
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(HoldingList, {
          shareClass: shareClass,
          fHoldingsMap: fHoldingsMap,
          holdings: holdings,
          page: page,
          label: label
        }),
        _react2.default.createElement(
          'div',
          { styleName: 'show-more-holdings-btn-wrap' },
          hasMoreButton
        )
      );
    }
  }]);
  return HoldingListDisplay;
}(_react.Component), _class6.propTypes = {
  increment: _react.PropTypes.func,
  shareClass: _react.PropTypes.object,
  fHoldingsMap: _react.PropTypes.object,
  type: _react.PropTypes.string,
  label: _react.PropTypes.string,
  count: _react.PropTypes.string,
  holdings: _react.PropTypes.array,
  pages: _react.PropTypes.object
}, _temp3)) || _class5);
var HoldingList = (_dec4 = (0, _reactCssModules2.default)(_FundFossilFinanceInvestments2.default, { allowMultiple: true }), _dec4(_class7 = (_temp4 = _class8 = function (_Component4) {
  (0, _inherits3.default)(HoldingList, _Component4);

  function HoldingList(props) {
    (0, _classCallCheck3.default)(this, HoldingList);
    return (0, _possibleConstructorReturn3.default)(this, (HoldingList.__proto__ || (0, _getPrototypeOf2.default)(HoldingList)).call(this, props));
  }

  (0, _createClass3.default)(HoldingList, [{
    key: 'render',
    value: function render() {
      var _this5 = this;

      var _props4 = this.props,
          shareClass = _props4.shareClass,
          fHoldingsMap = _props4.fHoldingsMap,
          holdings = _props4.holdings,
          page = _props4.page;


      if (!holdings || holdings.length === 0) {
        return _react2.default.createElement(
          'div',
          null,
          'ERROR'
        );
      }

      var takeCount = page > 1 ? AllPage : FirstPage;
      //
      return _react2.default.createElement(
        'ul',
        { styleName: 'holding-list' },
        _react2.default.createElement(
          'li',
          { styleName: 'holding holding-list-labels' },
          _react2.default.createElement(
            'div',
            { styleName: 'holding-name hidden-xs' },
            'Holding'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'holding-values-labels hidden-xs' },
            _react2.default.createElement(
              'div',
              { styleName: 'holding-value' },
              'Risk score'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'holding-value' },
              '$ invested'
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'holding-value' },
              '% of fund'
            )
          )
        ),
        (0, _lodash.chain)(holdings).take(takeCount).map(function (h, idx) {
          // useful formats
          var fPerc = _format2.default.perc(fHoldingsMap[h.id].long_weight);
          var fMoney = _format2.default.money(fHoldingsMap[h.id].market_value, true, shareClass.currency, true);
          var bankScore = _format2.default.number(h.fossil_bank_score, false, false, 2);
          var insureScore = _format2.default.number(h.fossil_insure_score, false, false, 2);
          //
          return _react2.default.createElement(
            'li',
            { key: idx },
            _react2.default.createElement(
              _components.FinanceCompanyProfileModal,
              {
                holding: h,
                fundholding: fHoldingsMap[h.id]
              },
              _react2.default.createElement(
                'div',
                { styleName: 'holding holding-hover' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'holding-name' },
                  idx + 1,
                  '. \xA0',
                  _react2.default.createElement(
                    'b',
                    null,
                    h.security_name
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'holding-values' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'holding-value' },
                    _this5.props.label === 'Banks' ? _react2.default.createElement(_components.FinanceCompanyScore, { score: bankScore }) : _react2.default.createElement(_components.FinanceCompanyScore, { score: insureScore })
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'holding-value' },
                    fMoney
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'holding-value' },
                    fPerc
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'holding-values-labels hidden-sm hidden-md hidden-lg' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'holding-value' },
                    'Risk score'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'holding-value' },
                    'invested'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'holding-value' },
                    'of fund'
                  )
                )
              )
            )
          );
        }).value()
      );
    }
  }]);
  return HoldingList;
}(_react.Component), _class8.propTypes = {
  shareClass: _react.PropTypes.object,
  fHoldingsMap: _react.PropTypes.object,
  holdings: _react.PropTypes.array,
  page: _react.PropTypes.number,
  label: _react.PropTypes.string
}, _temp4)) || _class7);
var GradeBox = (_dec5 = (0, _reactCssModules2.default)(_FundFossilFinanceInvestments2.default, { allowMultiple: true }), _dec5(_class9 = (_temp5 = _class10 = function (_Component5) {
  (0, _inherits3.default)(GradeBox, _Component5);

  function GradeBox(props) {
    (0, _classCallCheck3.default)(this, GradeBox);
    return (0, _possibleConstructorReturn3.default)(this, (GradeBox.__proto__ || (0, _getPrototypeOf2.default)(GradeBox)).call(this, props));
  }

  (0, _createClass3.default)(GradeBox, [{
    key: 'render',
    value: function render() {
      var _props5 = this.props,
          grade = _props5.grade,
          score = _props5.score,
          type = _props5.type;

      var GR = _format2.default.score(grade);
      var gr = GR.toLowerCase();

      var tip = {
        'finance': _format2.default.scoreTipFossilFinance,
        'insurance': _format2.default.scoreTipFossilInsurance
      }[type](_convert2.default.float(score), GR);

      var methodologyAnchor = {
        'finance': 'methodology-fossil-fuel-finance',
        'insurance': 'methodology-fossil-fuel-insurance'
      }[type];

      //
      return _react2.default.createElement(
        'div',
        { styleName: 'grade-snapshot-' + gr },
        _react2.default.createElement(
          'div',
          { styleName: 'grade-intro' },
          _react2.default.createElement(
            'div',
            { styleName: 'grade-intro-tip' },
            tip
          ),
          _react2.default.createElement('br', null),
          _react2.default.createElement(
            _components.Link,
            {
              strong: true,
              to: _config2.default.routes.banksInsurance + '#' + methodologyAnchor,
              title: 'Methodology'
            },
            _react2.default.createElement(
              'strong',
              null,
              'Methodology',
              _react2.default.createElement(_components.LinkIcon, null)
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'grade-wrapper' },
          _react2.default.createElement(_components.Grade, {
            grade: grade,
            large: true
          }),
          _react2.default.createElement(_components.FinanceFundScore, { score: score, grade: grade })
        )
      );
    }
  }]);
  return GradeBox;
}(_react.Component), _class10.propTypes = {
  grade: _react.PropTypes.number,
  score: _react.PropTypes.string,
  type: _react.PropTypes.string
}, _temp5)) || _class9);
var FundFossilFinanceInvestments = (_dec6 = (0, _reactRedux.connect)(function (state) {
  return {
    result: state.shareClass.result,
    loading: state.shareClass.loading,
    loaded: state.shareClass.loaded,
    error: state.shareClass.error
  };
}, searchActions), _dec7 = (0, _reduxAsyncConnect.asyncConnect)([{
  deferred: true, // need otherwise client navigate blocked until page loaded
  promise: function promise(_ref) {
    var params = _ref.params,
        _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState;

    return dispatch(searchActions.shareClassDetails(params.fundId, params.investmentVehicleId));
  }
}]), _dec8 = (0, _reactCssModules2.default)(_FundFossilFinanceInvestments2.default, { allowMultiple: true }), _dec6(_class11 = _dec7(_class11 = _dec8(_class11 = (_temp6 = _class12 = function (_Component6) {
  (0, _inherits3.default)(FundFossilFinanceInvestments, _Component6);

  function FundFossilFinanceInvestments(props) {
    (0, _classCallCheck3.default)(this, FundFossilFinanceInvestments);

    var _this7 = (0, _possibleConstructorReturn3.default)(this, (FundFossilFinanceInvestments.__proto__ || (0, _getPrototypeOf2.default)(FundFossilFinanceInvestments)).call(this, props));

    _this7.increment = function (incState) {
      return function () {
        var newState = { sectorPages: { 'ffb': 1, 'ffi': 1 } };
        newState.sectorPages[incState] = _this7.state.sectorPages[incState] + 1;
        _this7.setState(newState);
      };
    };

    _this7.increment = _this7.increment.bind(_this7);
    _this7.state = {
      sectorPages: {
        ffb: 1,
        ffi: 1
      }
    };
    return _this7;
  }

  (0, _createClass3.default)(FundFossilFinanceInvestments, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      _analytics2.default.event(_analytics2.default.eventLoadFund(this.props.params.fundId, this.props.params.investmentVehicleId));
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {}

    // need this solution since asyncConnect and anchor links does not play nice
    // scrollTo = (id) => {
    //   return () => {
    //     const ele = document.getElementById(id)
    //     window.scrollTo(ele.offsetLeft, ele.offsetTop)
    //   }
    // }

  }, {
    key: 'render',
    value: function render() {
      var _this8 = this;

      // loading icons
      if (!this.props.result) {
        return _react2.default.createElement(
          'div',
          { styleName: 'main' },
          _react2.default.createElement(_reactLoader2.default, {
            options: { scale: 0.70, top: '2.0rem' },
            loaded: false
          })
        );
      } else if (this.props.result && (!this.props.result.fund || !this.props.result.shareClass)) {
        this.context.router.push(_config2.default.routes.notFound);
        return _react2.default.createElement(
          'div',
          { styleName: 'main' },
          _react2.default.createElement(_reactLoader2.default, {
            options: { scale: 0.70, top: '2.0rem' },
            loaded: false
          })
        );
      }

      var _props$result = this.props.result,
          fund = _props$result.fund,
          shareClass = _props$result.shareClass;
      var holdings = fund.holdings,
          fundholdings = fund.fundholdings;

      var title = shareClass.fund_legal_name + ' | Banks and insurers';
      var url = _config2.default.domain + this.props.location.pathname;

      // dividing up holdings by sector groups
      // could this be cached (e.g. in state) to improve performance?
      var fHoldingsMap = mapFundHoldings(fundholdings);
      var ffbHoldings = filterHoldings(fHoldingsMap, holdings, function (h) {
        return h.is_fossil_bank;
      });
      var ffiHoldings = filterHoldings(fHoldingsMap, holdings, function (h) {
        return h.is_fossil_insure;
      });

      // configs for "sector switch" totals and holdings lists
      var financeSectorConfig = [['ffb', 'Banks', 'Banks providing lending to fossil fuels', 'fossil_bank_count', 'fossil_bank_weight', 'fossil_bank_asset', ffbHoldings, 'fossil_bank_score']];

      var insuranceSectorConfig = [['ffi', 'Insurers', 'Insurance companies insuring and investing in fossil fuels', 'fossil_insure_count', 'fossil_insure_weight', 'fossil_insure_asset', ffiHoldings, 'fossil_insure_score']];

      var _ticker = shareClass.ticker || null;
      var fundName = '' + fund.fund_legal_name;
      fundName = _ticker ? fundName + ' ' + _ticker : fundName;

      var description = 'See if ' + fundName + ' is invested in banks and insurers financing the climate crisis.';

      return _react2.default.createElement(
        'div',
        null,
        _container2.default.helmet(title, description, url),
        _react2.default.createElement(
          'div',
          { styleName: 'fossil-fuel-banner-wrap' },
          _react2.default.createElement(
            _components.ContainerDivs,
            null,
            _react2.default.createElement(
              'h2',
              { styleName: 'fossil-fuel-banner-hl' },
              _react2.default.createElement(
                'span',
                { styleName: 'fossil-fuel-banner-hl-lg' },
                'Banks and insurers'
              ),
              _react2.default.createElement(
                'span',
                { styleName: 'fossil-fuel-banner-hl-sm' },
                'are financing the climate crisis.'
              )
            )
          )
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement(_components.FundMenu, {
          active: 'Banks & insurers',
          fundId: shareClass.fund_id,
          investmentVehicleId: shareClass.investment_vehicle_id,
          name: shareClass.fund_legal_name,
          ticker: shareClass.ticker
        }),
        _react2.default.createElement(_components.FundName, {
          shareClass: shareClass,
          pathname: this.props.location.pathname
        }),
        _react2.default.createElement(
          'div',
          { styleName: 'main' },
          _react2.default.createElement(
            _components.ContainerDivs,
            null,
            _react2.default.createElement(
              _reactFlexboxGrid.Row,
              { styleName: 'sidebar-content-wrap' },
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 12, sm: 12, md: 12, lg: 4, styleName: 'sidebar-wrap' },
                _react2.default.createElement(
                  'h3',
                  { styleName: 'sidebar-headline' },
                  'Fossil fuel finance'
                ),
                _react2.default.createElement(GradeBox, {
                  grade: fund.grade_fossil_bank,
                  score: fund.fossil_bank_score,
                  type: 'finance'
                })
              ),
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 12, sm: 12, md: 12, lg: 8, styleName: 'main-content-wrap' },
                _react2.default.createElement(
                  'h3',
                  { styleName: 'main-content-lede' },
                  'Commercial and investment banks\' carbon-intensive funding is fundamentally incompatible with reaching the 1.5-degree aligned global goal necessary to prevent catastrophic climate harm.'
                ),
                /* Bank sector details + holding list */
                financeSectorConfig.map(function (sector) {
                  return _react2.default.createElement(SectorDetailsSwitches, {
                    key: sector[0],
                    increment: _this8.increment,
                    sector: sector,
                    fund: fund,
                    shareClass: shareClass,
                    fHoldingsMap: fHoldingsMap,
                    sectorPages: _this8.state.sectorPages
                  });
                }),
                _react2.default.createElement(
                  'div',
                  { styleName: 'long-only-disclaimer' },
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(_components.LinkIcon, { nospace: true, faclass: 'fa-info-circle' })
                  ),
                  _react2.default.createElement(
                    'div',
                    null,
                    'When calculating a portfolio\'s screen exposure, we only consider long investments, ignoring any shorts or liabilities.'
                  )
                )
              )
            ),
            _react2.default.createElement(
              _reactFlexboxGrid.Row,
              { styleName: 'sidebar-content-wrap' },
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 12, sm: 12, md: 12, lg: 4, styleName: 'sidebar-wrap' },
                _react2.default.createElement(
                  'h3',
                  { styleName: 'sidebar-headline' },
                  'Fossil fuel insurance'
                ),
                _react2.default.createElement(GradeBox, {
                  grade: fund.grade_fossil_insure,
                  score: fund.fossil_insure_score,
                  type: 'insurance'
                })
              ),
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 12, sm: 12, md: 12, lg: 8, styleName: 'main-content-wrap' },
                _react2.default.createElement(
                  'h3',
                  { styleName: 'main-content-lede' },
                  'Primary insurers and reinsurers are continuing to underwrite and invest in coal, oil, and gas, while experiencing dramatic losses associated with catastrophic weather-related events.'
                ),
                /* Insurance sector details + holding list */
                insuranceSectorConfig.map(function (sector) {
                  return _react2.default.createElement(SectorDetailsSwitches, {
                    key: sector[0],
                    increment: _this8.increment,
                    sector: sector,
                    fund: fund,
                    shareClass: shareClass,
                    fHoldingsMap: fHoldingsMap,
                    sectorPages: _this8.state.sectorPages
                  });
                })
              )
            ),
            _react2.default.createElement('br', null),
            _react2.default.createElement(_components.InlineSignup, null)
          )
        ),
        _react2.default.createElement(_components.IyvScorecard, { fund: fund, shareClass: shareClass }),
        _react2.default.createElement(_components.FundShareTakeAction, { shareClass: shareClass, url: url })
      );
    }
  }]);
  return FundFossilFinanceInvestments;
}(_react.Component), _class12.propTypes = {
  loading: _react.PropTypes.bool,
  loaded: _react.PropTypes.bool,
  error: _react.PropTypes.object,
  result: _react.PropTypes.object
}, _class12.contextTypes = {
  router: _react.PropTypes.object.isRequired
}, _temp6)) || _class11) || _class11) || _class11);
exports.default = FundFossilFinanceInvestments;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/FundFossilFinanceInvestments/FundFossilFinanceInvestments.js
// module id = 1404
// module chunks = 0